import { IconStorage } from "@app/shared/icons/interfaces";

export const arrowNarrowDown: IconStorage = {
  svgCode: () => ([
    "M12 4V20M12 20L18 14M12 20L6 14",
  ]),
};

export const arrowNarrowRight: IconStorage = {
  svgCode: () => ([
    "M4 12H20M20 12L14 6M20 12L14 18",
  ]),
};

export const arrowNarrowUp: IconStorage = {
  svgCode: () => ([
    "M12 20V4M12 4L6 10M12 4L18 10",
  ]),
};
